export default "__VITE_ASSET__DccLKS$b__"